import { getRoot } from "mobx-state-tree"

export const feedbacksStoreViews = self => ({   
    get token() {
        return getRoot(self).authStore.token
      },
      get merchantId() {
        return getRoot(self).authStore.managingStore.id
      },
      get feedbacksFactory() {
        return getRoot(self).feedbacksFactory
      },
  })